import React, {useEffect, useState} from 'react';
import {Link, useLocation, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import ContratCreation from "../../../components/Admin/Contrat/ContratCreation";
import ContratsVue from "../../../components/Admin/Contrat/ContratsVue";
import styles from "../Admin.module.css";
import {ReactComponent as AjouterIcone} from "../../../icons/ajouter.svg";
import Routing from "../../../services/routing";
import ErrorPage from "../../Erreurs/ErrorPage";

function AdminContratsPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const {entrepriseId} = useParams();
    const [entreprise, setEntreprise] = useState({});
    const { updateBreadcrumb, updateDynamicBreadcrumb } = useBreadcrumb();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';


    useEffect(() => {
        (async () => {
            try {
                const response = await AxiosConfig.get(`/admin/entreprises/${entrepriseId}/contrats`);
                const parseData = response.data.myContrats;
                setMyApiData(parseData);
                setEntreprise(response.data.myEntreprise);
            } catch (error) {
                console.error('error', error);
            }
        })();
    }, [user, mode]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ entreprise }));
    }, [ entreprise ]);

    if (!entreprise || Object.keys(entreprise).length === 0) {
        return <ErrorPage title={"Page inaccessible"}/>;
    }

    return (
    <div className="content_tab">
        <TitleMain text="Contrats"/>

        {mode === 'creation' ?
            <ContratCreation entreprise={entreprise} /> :
            <>
                <div className={styles.navLink}>
                    <Link to={Routing.routes.adminCreation}>
                        <AjouterIcone />
                        Ajouter un contrat
                    </Link>
                </div>
                <ContratsVue entrepriseId={entrepriseId} />
            </>
        }
    </div>
    )
}

export default AdminContratsPage;
